<template>
  <div class="test_group_warp">
    <div class="left">
      <LeftController @initList="initData"
                      ref="subjectRef" />
    </div>
    <div class="right">
      <TopCard ref="TopCardRef"
               text="教师试卷"
               :showBack="false" />
                <div class="select_wrap">
        <!-- <div> -->
        <div class="tab">
          <div :class="typeIndex==2?'active':''"
 
           
 
               @click="changeType(2)">平台试卷</div>
          <div :class="typeIndex==1?'active':''"
          v-if="userInfo.edu_school_id!=1"
               @click="changeType(1)">本校试卷</div>
               <div :class="typeIndex==3?'active':''"
            v-if="isbx"
               @click="changeType(3)">伴学师试卷</div>
        </div>
        <!-- </div> -->
      </div>
      <div class="list">
        <div class="warp">
          <el-row v-for="(item,index) in tableData"
                  :key="index">
            <el-col :span="10">
              <div class="paper_name">
                <div class="img">
                  <img src="@/assets/choiceness/教师试卷.png"
                       alt="">
                </div>
                <div class="text">
                  <div>
                    {{item.paper_name}}
                  </div>
                  <div>
                    出卷教师:{{item.edu_user_name}} (教师试卷ID:{{item.edu_paper_id}})
                  </div>

                  <div>
                    {{item.paper_heading}}
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="score">
                {{item.paper_time}}
              </div>
            </el-col>

            <el-col :span="3">
              <div class="score">
                总分：{{item.paper_score}}
              </div>
            </el-col>
            <el-col :span="6">
              <div class="btn_warp">
                <div class="btn"
                     @click="doPaper(item)">
                  开始训练
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import LeftController from '@/views/components/left_controller.vue'
import TopCard from '@/views/components/top_card/index.vue'
import { getChoicenessPaper ,getBxSubjects} from '@/api/choiceness.js'
export default {
  data () {
    return {
      tableData: [],
      is_show_school:2,//0 本校加平台 1本校 2平台 
      typeIndex: 2, 
      userInfo:{},
      isbx:false,
      bxList:[]
    }
  },
  components: {
    LeftController, TopCard
  },
  mounted () {
      this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.$removePaperInfo()
    this.typeIndex =   2
    
    this.getList( )
     
       
  },
  activated () {
    if (!this.$refs.subjectRef.subjectList.length) {
      this.$refs.subjectRef.initData()
    }
  },
beforeRouteEnter(to, from, next) {
  console.log('进入当前页面前的路由 from:', from);

  next(vm => {
    // 通过 vm 访问组件实例
    vm.previousRoute = from;

    if (from.path === '/free') {
      vm.is_show_school = 1;
    }
  });
},
  methods: {
     changeType (index) {
      this.typeIndex = index
     this.is_show_school = index
      window.localStorage.setItem('typeData', index)
     
      // this.initData(window.sessionStorage.getItem('checkSubjectId'))
 
        if(index==3){
          console.log("8789",this.bxList)
          this.$refs.subjectRef.subjectList =this.bxList
        }else{
           this.$refs.subjectRef.initData()
        }
       
      
        this.initData(this.$refs.subjectRef.subjectList[0].subject_id)
        setTimeout((
          
        ) => {  this.$refs.subjectRef.subjectId = this.$refs.subjectRef.subjectList[0].subject_id

        },1000)
          
   
    },
    async initData (id) {
      let params = {
        subject_id: id,
        subject_consultation: 0,
        is_show_school: window.localStorage.getItem('typeData')||this.is_show_school
      }
    
       
      const { data } = await getChoicenessPaper(params)
      this.tableData = data.list
      //  this.getList(id)
    },
    async getList(id){
        
   let params = {
       
      }
      const { data } = await getBxSubjects(params)
      this.bxList= data.list
      if(data.list.length>0){
        this.isbx = true
      } 
       
    },
    doPaper (item) {
      let params = {
        edu_paper_id: item.edu_paper_id,
        paper_duration:item.paper_duration
      }
      this.$router.push('/doPaper?type=4&form=' + JSON.stringify(params))
    }
  }
}
</script>

<style lang="scss" scoped>
  .ant-modal{
  width: 630px;
}
.test_group_warp {
  overflow: hidden;
  display: flex;
  .left {
    width: 100rem;
  }
  .right {
    width: calc(100% - 100rem);
    background: #f6f6f6;
    .select_wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  .tab {
  padding-bottom: 32rem;
  padding-left: 32rem;
  div {
    margin-right: 2rem;
    display: inline-block;
    width: 144rem;
    line-height: 44rem;
    text-align: center;
   font-size: 28rem;
    color: #666;
    cursor: pointer;
  }
  .active {
    font-size: 28rem;
    color: #2196f3;
    position: relative;
    &::after {
      content: "";
      width: 128rem;
      height: 6rem;
      position: absolute;
      display: block;
      bottom: -26rem;
      left: 4rem;
      border-radius: 20rem;
      background: #2196f3;
    }
  }
}
}
 
 
    .tabs {
      margin-top: 22rem;
      display: flex;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 18rem;
      .tab {
        cursor: pointer;
        width: 260rem;
        height: 54rem;
        background: #2196f3;
        border-radius: 30rem;
        color: #ffffff;
        font-size: 24rem;
        font-weight: 800;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .list {
      width: 100%;
      max-height: calc(100vh - 60rem - 40rem);
      -ms-overflow-style: none;
      background: white;
      overflow-y: auto;
      overflow: -moz-scrollbars-none;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      .el-row {
        // height: 140rem;
        height: fit-content;
        padding: 8rem 0;
        border-bottom: 1rem solid #f1f1f1;
        &:hover {
          background: rgba($color: #2196f3, $alpha: 0.1);
        }
      }
      // div {
      //   height: 80rem;
      //   line-height: 80rem;
      // }
      .paper_name {
        margin-left: 50rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        // height: 140rem;
        height: fit-content;
        .img {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 120rem;
          height: 100rem;
          background: #6cb9f5;
          border-radius: 5rem;
          img {
            width: 34rem;
            height: 34rem;
          }
        }
        .text {
          // height: 100rem;
          margin-left: 20rem;
          height: fit-content;
          flex: 1;
          div {
            &:nth-child(1) {
              font-size: 20rem;
              font-weight: bold;
              color: #000000;
            }
            &:nth-child(2) {
              margin-top: 10rem;
              font-size: 20rem;
              font-weight: bold;
              color: #000000;
            }
            &:nth-child(3) {
              margin-top: 10rem;
              font-weight: 500;
              font-size: 20rem;
              color: #333333;
            }
          }
        }
      }
      .score {
        font-weight: 500;
        color: #333333;
        font-size: 20rem;
        height: 110rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
      .btn_warp {
        display: flex;
        height: 110rem;
        align-items: center;
        justify-content: flex-end;
        .btn {
          width: 120rem;
          height: 44rem;
          background: #2196f3;
          margin-right: 20rem;
          border-radius: 5rem;
          font-size: 20rem;
          font-weight: bold;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }
  }
}
</style>